import { createSelector } from "reselect";
import { LAST_MONTH, LAST_THREE_MONTHS, LAST_WEEK } from "../../components/constants";
import { Interval } from "../../components/reports/types";
import { ReportsState } from "../models/reports";
import { State } from "../reducers/root";
import { pickBy } from "lodash-es";

type ReportPoint = {
  key: string;
  count: number;
};
export type ReportsAccumulated = Partial<{
  bookings: ReportPoint[];
  telLookups: ReportPoint[];
  pageVisits: ReportPoint[];
}>;

const intervalToStartDay = {
  [LAST_MONTH]: -30,
  [LAST_THREE_MONTHS]: -90,
  [LAST_WEEK]: -7,
};
const accumulateData = <T extends Array<any> = ReportPoint[]>(array: T): T => {
  const a = array?.reduce((accumulator: T, currentValue: { key: any; count: any }): T => {
    const index = accumulator.findIndex((item: { key: any }) => item.key === currentValue.key);

    if (index >= 0) {
      const element = accumulator[index];
      const tmp = { key: element.key, count: element.count };
      tmp.count = currentValue.count + element.count;
      const newAccumulator = accumulator.slice();
      newAccumulator.splice(index, 1, tmp) as T;
      return newAccumulator as T;
    } else {
      accumulator.push(currentValue);
      return accumulator;
    }
  }, []);

  return a;
};

const getInterval = (_1: any, _2: any, interval: Interval): Interval => {
  return interval;
};

export const filterInterval = (data?: any[], interval?: Interval | null) => {
  if (data) {
    if (interval) return data?.slice(intervalToStartDay[interval]);
    else return data;
  }
};

const getReports = (state: State): ReportsState => {
  return state.reports;
};

const getOffices = (state: State) => {
  return state.offices.data;
};

const getDoctorId = (_1: any, doctorId: number) => {
  return doctorId;
};

export const reportsAccumulatedSelector = createSelector(
  [getReports, getInterval, getOffices, getDoctorId],
  (allReports, interval, offices) => {
    const officeIds = offices.map((i) => i.id);
    const officeReport = pickBy(allReports, (v, k) => officeIds.includes(parseInt(k)));

    const reports = Object.values(officeReport);
    const reportsData = reports.reduce<ReportsAccumulated>((a, c) => {
      if (c.bookings?.data) a.bookings = a.bookings ? [...a.bookings, ...c.bookings.data] : [...c.bookings.data];
      return a;
    }, {});
    const result = {
      bookings: reportsData.bookings && filterInterval(accumulateData(reportsData.bookings), interval),
      telLookups: allReports[0]?.telLookups && filterInterval(accumulateData(allReports[0].telLookups.data), interval),
      pageVisits: allReports[0]?.pageVisits && filterInterval(accumulateData(allReports[0].pageVisits.data), interval),
    };
    return result;
  }
);
